var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75814 3.52734C5.4248 3.52734 2.57814 5.60068 1.4248 8.52734C2.57814 11.454 5.4248 13.5273 8.75814 13.5273C12.0915 13.5273 14.9381 11.454 16.0915 8.52734C14.9381 5.60068 12.0915 3.52734 8.75814 3.52734ZM8.75814 11.8607C6.91814 11.8607 5.4248 10.3673 5.4248 8.52734C5.4248 6.68734 6.91814 5.19401 8.75814 5.19401C10.5981 5.19401 12.0915 6.68734 12.0915 8.52734C12.0915 10.3673 10.5981 11.8607 8.75814 11.8607ZM8.75814 6.52734C7.65147 6.52734 6.75814 7.42068 6.75814 8.52734C6.75814 9.63401 7.65147 10.5273 8.75814 10.5273C9.8648 10.5273 10.7581 9.63401 10.7581 8.52734C10.7581 7.42068 9.8648 6.52734 8.75814 6.52734Z",
    fill: "#576EDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEyeIcon);
export default __webpack_public_path__ + "static/media/blueEyeIcon.fa5468bf517225a2947c1f4132a9fdb1.svg";
export { ForwardRef as ReactComponent };